import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 kn-flex" }
const _hoisted_2 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = {
  id: "drivers-list-container",
  class: "kn-flex kn-relative"
}
const _hoisted_4 = {
  key: 0,
  id: "driver-details-container",
  class: "kn-flex kn-relative"
}
const _hoisted_5 = { class: "p-m-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "p-fluid p-formgrid p-grid p-m-1" }
const _hoisted_8 = { class: "p-field p-col-12" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field p-col-12" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  key: 0,
  class: "p-dropdown-driver-value"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "p-dropdown-driver-option" }
const _hoisted_16 = {
  for: "analytical",
  class: "kn-material-input-label"
}
const _hoisted_17 = { class: "p-field p-col-12" }
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = {
  for: "parameterUrlName",
  class: "kn-material-input-label"
}
const _hoisted_20 = { class: "p-field p-col-12 p-md-4 p-jc-center p-mt-3" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "far fa-eye p-ml-2" }, null, -1)
const _hoisted_22 = {
  for: "visible",
  class: "kn-material-input-label p-ml-2"
}
const _hoisted_23 = { class: "p-field p-col-12 p-md-4 p-jc-center p-mt-3" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fas fa-asterisk p-ml-2" }, null, -1)
const _hoisted_25 = {
  for: "required",
  class: "kn-material-input-label p-ml-2"
}
const _hoisted_26 = { class: "p-field p-col-12 p-md-4 p-jc-center p-mt-3" }
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "fas fa-list p-ml-2" }, null, -1)
const _hoisted_28 = {
  for: "multivalue",
  class: "kn-material-input-label p-ml-2"
}
const _hoisted_29 = {
  key: 2,
  class: "p-grid p-mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnListBox = _resolveComponent("KnListBox")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_DataConditions = _resolveComponent("DataConditions")
  const _component_VisibilityConditions = _resolveComponent("VisibilityConditions")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.title')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.add'),
            class: "p-button-text p-button-rounded p-button-plain kn-white-color",
            onClick: _ctx.addNewDriver
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          style: _ctx.mainDescriptor.style.absoluteScroll
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                class: "kn-progress-bar",
                mode: "indeterminate",
                "data-test": "progress-bar"
              }))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_KnListBox, {
                key: 1,
                class: "kn-height-full",
                options: _ctx.document.drivers,
                settings: _ctx.driversDescriptor.knListSettings,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectDriver($event.item))),
                onDelete: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.deleteDriverConfirm($event)), ["stop"])),
                onMoveUp: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.movePriority($event.item, 'up')), ["stop"])),
                onMoveDown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.movePriority($event.item, 'down')), ["stop"]))
              }, null, 8, ["options", "settings"]))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ]),
    _createVNode("div", {
      class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0",
      style: _ctx.mainDescriptor.style.driverDetailsContainer
    }, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.detailsTitle')), 1)
        ]),
        _: 1
      }),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", {
              style: _ctx.mainDescriptor.style.absoluteScroll
            }, [
              _createVNode("div", _hoisted_5, [
                (Object.keys(_ctx.selectedDriver).length === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode(_component_InlineMessage, {
                        severity: "info",
                        class: "kn-width-full"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.noDriverSelected')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createBlock(_component_Card, { key: 1 }, {
                      content: _withCtx(() => [
                        _createVNode("form", _hoisted_7, [
                          _createVNode("div", _hoisted_8, [
                            _createVNode("span", _hoisted_9, [
                              _createVNode(_component_InputText, {
                                id: "label",
                                class: ["kn-material-input", {
                                                    'p-invalid': _ctx.v$.selectedDriver.label.$invalid && _ctx.v$.selectedDriver.label.$dirty
                                                }],
                                type: "text",
                                maxLength: "40",
                                modelValue: _ctx.v$.selectedDriver.label.$model,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.selectedDriver.label.$model = $event)),
                                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.selectedDriver.label.$touch())),
                                onChange: _ctx.markSelectedDriverForChange
                              }, null, 8, ["modelValue", "class", "onChange"]),
                              _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.title')) + " * ", 1)
                            ]),
                            _createVNode(_component_KnValidationMessages, {
                              class: "p-mt-1",
                              vComp: _ctx.v$.selectedDriver.label,
                              additionalTranslateParams: { fieldName: _ctx.$t('common.title') }
                            }, null, 8, ["vComp", "additionalTranslateParams"])
                          ]),
                          _createVNode("div", _hoisted_11, [
                            _createVNode("span", _hoisted_12, [
                              _createVNode(_component_Dropdown, {
                                id: "analytical",
                                class: ["kn-material-input", {
                                                    'p-invalid': _ctx.v$.selectedDriver.parameter.$invalid && _ctx.v$.selectedDriver.parameter.$dirty
                                                }],
                                modelValue: _ctx.v$.selectedDriver.parameter.$model,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.selectedDriver.parameter.$model = $event)),
                                options: _ctx.availableAnalyticalDrivers,
                                optionLabel: "label",
                                filter: true,
                                filterPlaceholder: _ctx.$t('documentExecution.documentDetails.drivers.dropdownSearchHint'),
                                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.selectedDriver.parameter.$touch())),
                                onChange: _ctx.changeDriverValue
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                        _createVNode("span", null, _toDisplayString(slotProps.value.label), 1)
                                      ]))
                                    : (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createVNode("div", _hoisted_15, [
                                    _createVNode("span", null, _toDisplayString(slotProps.option.label), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "options", "class", "filterPlaceholder", "onChange"]),
                              _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.businessModelManager.analyticalDriver')), 1)
                            ]),
                            _createVNode(_component_KnValidationMessages, {
                              class: "p-mt-1",
                              vComp: _ctx.v$.selectedDriver.parameter,
                              additionalTranslateParams: { fieldName: _ctx.$t('managers.businessModelManager.analyticalDriver') }
                            }, null, 8, ["vComp", "additionalTranslateParams"])
                          ]),
                          _createVNode("div", _hoisted_17, [
                            _createVNode("span", _hoisted_18, [
                              _createVNode(_component_InputText, {
                                id: "parameterUrlName",
                                class: ["kn-material-input", {
                                                    'p-invalid': _ctx.v$.selectedDriver.parameterUrlName.$invalid && _ctx.v$.selectedDriver.parameterUrlName.$dirty
                                                }],
                                type: "text",
                                maxLength: "20",
                                modelValue: _ctx.v$.selectedDriver.parameterUrlName.$model,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.selectedDriver.parameterUrlName.$model = $event)),
                                onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.selectedDriver.parameterUrlName.$touch())),
                                onChange: _ctx.markSelectedDriverForChange
                              }, null, 8, ["modelValue", "class", "onChange"]),
                              _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.parameterUrlName')) + " * ", 1)
                            ]),
                            _createVNode(_component_KnValidationMessages, {
                              class: "p-mt-1",
                              vComp: _ctx.v$.selectedDriver.parameterUrlName,
                              additionalTranslateParams: { fieldName: _ctx.$t('documentExecution.documentDetails.drivers.parameterUrlName') },
                              specificTranslateKeys: { custom_unique: 'managers.businessModelManager.driversUrlNotUnique' }
                            }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
                          ]),
                          _createVNode("span", _hoisted_20, [
                            _createVNode(_component_InputSwitch, {
                              id: "visible",
                              modelValue: _ctx.selectedDriver.visible,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedDriver.visible = $event)),
                              onChange: _ctx.markSelectedDriverForChange
                            }, null, 8, ["modelValue", "onChange"]),
                            _hoisted_21,
                            _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('common.visible')), 1)
                          ]),
                          _createVNode("span", _hoisted_23, [
                            _createVNode(_component_InputSwitch, {
                              id: "required",
                              modelValue: _ctx.selectedDriver.required,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedDriver.required = $event)),
                              onChange: _ctx.markSelectedDriverForChange
                            }, null, 8, ["modelValue", "onChange"]),
                            _hoisted_24,
                            _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('common.required')), 1)
                          ]),
                          _createVNode("span", _hoisted_26, [
                            _createVNode(_component_InputSwitch, {
                              id: "multivalue",
                              modelValue: _ctx.selectedDriver.multivalue,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectedDriver.multivalue = $event)),
                              onChange: _ctx.markSelectedDriverForChange
                            }, null, 8, ["modelValue", "onChange"]),
                            _hoisted_27,
                            _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('managers.businessModelManager.multivalue')), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })),
                (_ctx.document.drivers.length > 1 && _ctx.selectedDriver.id)
                  ? (_openBlock(), _createBlock("div", _hoisted_29, [
                      _createVNode(_component_DataConditions, {
                        availableDrivers: _ctx.document.drivers,
                        selectedDocument: _ctx.selectedDocument,
                        selectedDriver: _ctx.selectedDriver
                      }, null, 8, ["availableDrivers", "selectedDocument", "selectedDriver"]),
                      (_ctx.selectedDocument.engine)
                        ? (_openBlock(), _createBlock(_component_VisibilityConditions, {
                            key: 0,
                            availableDrivers: _ctx.document.drivers,
                            selectedDocument: _ctx.selectedDocument,
                            selectedDriver: _ctx.selectedDriver
                          }, null, 8, ["availableDrivers", "selectedDocument", "selectedDriver"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}